import MuiBox, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { forwardRef } from 'react';

interface BoxProps extends MuiBoxProps {}

export const Box = forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
	return <MuiBox ref={ref} {...props} />;
});
